import { useCallback } from 'react'
import { toast } from 'sonner'
import { useTranslation } from 'react-i18next'

export function useClipboard() {
  const { t } = useTranslation()
  const copy = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      toast.success(t('toastTip.copySuccess'))
    } catch {
      toast.error(t('toastTip.copyFail'))
    }
  }, [t])
  return { copy }
}
